import { useNavigate } from 'react-router-dom';

import { termsList, resTermListProps } from '@/api/server/terms/read';
import { Fragment, useEffect, useState } from 'react';
import SFMenu from '@/component/my/sf-menu';
import Divider from '@mui/material/Divider';
import ErrorRes from '@/api/server/ErrorRes';

export default function TermsAllList() {
  const navigate = useNavigate();
  const [list, setList] = useState<resTermListProps[]>([]);
  useEffect(() => {
    (async () => {
      const re = await termsList();
      if (re.ret_code !== 200) {
        ErrorRes({ code: re.ret_code, msg: re.msg });
        return;
      }
      setList(re.data);
    })();

    return () => {};
  }, []);

  return (
    <>
      {list.length > 0
        ? list.map((item: any) => (
            <Fragment key={item.terms_id}>
              <SFMenu.ArrowRightItem
                text={item.title}
                onClick={() => {
                  navigate(`/terms/${item.terms_id}/${item.terms_type}`);
                }}
              />
              <Divider sx={{ my: 2 }} />
            </Fragment>
          ))
        : ''}
    </>
  );
}
